import React from 'react';
import { InputSelect } from '~/components/NovosInputs';
import { useModulos } from '~/components/OrderTelas/data/Modulos';
import { useTela } from '~/components/OrderTelas/OrderTelasContext';

export const ModulosContainer: React.FC = () => {
  const { modulos } = useModulos();

  const { formTela } = useTela();

  const { register, formState, control, setValue } = formTela;

  const { errors } = formState;

  // Ordenar os módulos em ordem alfabética
  const sortedModulos = React.useMemo(
    () =>
      modulos
        .slice()
        .sort((a, b) =>
          a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }),
        ),
    [modulos],
  );

  return (
    <>
      <InputSelect
        label="Módulo"
        placeholder="- Selecione o módulo -"
        name="cod_modulo"
        register={register}
        isError={!!errors.cod_modulo}
        control={control}
        options={sortedModulos}
        changeSelected={(selected) => {
          setValue('cod_modulo_secao', null);
          setValue('cod_modulo', selected);
        }}
      />
    </>
  );
};
